import { inject } from '@angular/core';
import { AuthenticationService } from '../authentication-service/authentication.service';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

export const RedirectGuard = (route: ActivatedRouteSnapshot) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const authenticationService: AuthenticationService = inject(AuthenticationService);
  const router = inject(Router);

  const userRoles = authenticationService.getUserRoles();

  const homePages = route.data['homePages'];
  for (const homePage of homePages) {
    if (homePage.roles.every((role: string) => userRoles.includes(role))) {
      return router.createUrlTree([homePage.routePath]);
    }
  }

  return router.createUrlTree(['/default']);
};
